module.exports = __webpack_public_path__ + "static/media/page-header.747cdf9e.jpg";